import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SignUpLogo from "../../components/SignUpLogo";
import { useAuth } from "../../context";
import "./login.scss";
import { ClipLoader } from "react-spinners";
import { useRole } from "../../context/RoleContext";

export const Login = () => {
  const { role, setRole } = useRole();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [roles, setUserRole] = useState<string>("");
  const [error, setError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [inputType, setInputType] = useState<string>("password");
  const { login } = useAuth();

  const navigate = useNavigate();

  function handleToggle() {
    setShowPassword(!showPassword);
    setInputType(showPassword ? "password" : "text");
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const url = "https://core.pluritongues.com/auth/login";
    const payload = { email, password, role: roles };
    setError(undefined);
    setLoading(true);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errors = await response.json();
        throw new Error(errors.message ?? "Invalid credentials");
      }

      const data = await response.json();
      // const role = data.result.userDetails.profile; //data.result.userDetails.role.type;

      // if (role !== "merchant") {
      //   throw new Error("Invalid merchant Id provided");
      // }
      localStorage.setItem("token", data.result.accessToken);
      localStorage.setItem("id", data.result.userDetails.id);
      localStorage.setItem("Role", data.result.userDetails?.profile);

      localStorage.setItem(
        "teacherId",
        data.result.teacherProfile ? data.result.teacherProfile?.id : null
      );

      setRole(data.result.userDetails?.profile);
      navigate("/home");
    } catch (error: any) {
      console.log("Error at the catch block is:" + " " + error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="layout">
      <div className="login-wrapper side-bar">
        <div className="logo-wrapper">
          <SignUpLogo />
          <h3>Sign In</h3>
        </div>

        <form className="field-wrapper" onSubmit={handleSubmit}>
          {error && <p className="error-message">{error}</p>}
          <div className="inputDiv">
            <label htmlFor="email">Email</label>
            <input
              className="genInput"
              type="email"
              value={email}
              placeholder="email"
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
              data-test="email"
            />
          </div>

          <div className="inputDiv">
            <label>Password</label>
            <div className="passDiv">
              <input
                className="genInput"
                type={inputType}
                value={password}
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)}
                required
                data-test="password"
              />

              <div
                onClick={handleToggle}
                className="show-toggle"
                data-test="toogle"
              >
                {showPassword ? (
                  <i className="fa-solid fa-eye-slash"></i>
                ) : (
                  <i className="fa-solid fa-eye"></i>
                )}
              </div>
            </div>
          </div>
          <div className="radios">
            <span>Sign in as:</span>
            <div className="radopt">
              <input
                type="radio"
                name="userRole"
                value="teacher"
                id="teacher"
                onChange={(e) => setUserRole(e.target.value)}
                required
              />
              <label htmlFor="teacher" className="radLabel">
                As Teacher
              </label>
            </div>
            <div className="radopt">
              <input
                type="radio"
                name="userRole"
                value="partner"
                id="partner"
                onChange={(e) => setUserRole(e.target.value)}
                required
              />
              <label htmlFor="partner" className="radLabel">
                As Partner
              </label>
            </div>
          </div>

          <div className="btnCont">
            <button
              className="submit-btn"
              type="submit"
              disabled={loading}
              data-test="login"
            >
              {loading ? <ClipLoader color="white" size={20} /> : "Sign In"}{" "}
            </button>
          </div>
        </form>
        <div className="otherRoute">
          <Link className="recover" to="https://staging-app.pluritongues.com/forgot-password?from=merchant">
            <span> FORGOT PASSWORD</span>
          </Link>

          <div className="regRoute">
            <a href="https://register-teacher.pluritongues.com/">
              Register As A Language Tutor
            </a>
          </div>
          <div className="regRoute">
            <Link to="/Register-as-partner">
              Register As A Language Partner
            </Link>
          </div>
        </div>
        <p className="footer-login">
          &copy; right <a href="https://pluritongues.com">Pluritongues</a>. All
          rights reserved
        </p>
      </div>
      <div className="main-wrapper"></div>
    </div>
  );
};
